<!-- Hero Section -->
<section class="relative min-h-screen flex items-center overflow-hidden bg-gradient-to-br from-gray-900 via-blue-900 to-indigo-900">
  <!-- Animated Background Elements -->
  <div class="absolute inset-0 z-0">
    <div class="absolute top-1/4 left-1/4 w-64 h-64 bg-blue-500 rounded-full filter blur-3xl opacity-10 animate-pulse"></div>
    <div class="absolute bottom-1/3 right-1/4 w-72 h-72 bg-indigo-500 rounded-full filter blur-3xl opacity-10 animate-pulse"></div>
    <div class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-purple-500 rounded-full filter blur-3xl opacity-5 animate-ping"></div>
  </div>
  
  <!-- Grid Pattern Overlay -->
  <div class="absolute inset-0 z-0 opacity-10">
    <div class="absolute inset-0" style="background-image: radial-gradient(circle at 10% 20%, rgba(255,255,255,0.1) 1px, transparent 1px); background-size: 30px 30px;"></div>
  </div>
  
  <div class="container mx-auto px-4 py-20 relative z-10">
    <div class="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
      <div class="text-center lg:text-left">
        <div class="inline-block bg-gradient-to-r from-blue-500/20 to-purple-500/20 backdrop-blur-sm px-6 py-3 rounded-full mb-8 border border-blue-500/30">
          <span class="text-lg font-medium text-blue-300 flex items-center">
            <i class="bx bx-shield-quarter mr-2 text-xl"></i>Continuous Data Protection
          </span>
        </div>
        
        <h1 class="text-5xl md:text-6xl lg:text-7xl font-bold mb-8 leading-tight">
          <span class="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-cyan-300">Continuous</span> Data <span class="text-white">Protection</span>
        </h1>
        
        <p class="text-xl text-gray-300 mb-10 max-w-2xl">
          Enterprise-grade continuous data protection for IIS applications with real-time backup, instant recovery, and zero data loss protection for your critical business data.
        </p>
        
        <div class="flex flex-col sm:flex-row gap-6 justify-center lg:justify-start mb-12">
          <a routerLink="/contact" class="bg-gradient-to-r from-blue-600 to-indigo-700 hover:from-blue-700 hover:to-indigo-800 text-white font-bold py-4 px-10 rounded-xl transition-all duration-300 transform hover:-translate-y-1 shadow-2xl hover:shadow-blue-500/20 flex items-center justify-center group">
            <span>Start Protection</span>
            <i class="bx bx-right-arrow-alt ml-2 text-xl group-hover:translate-x-1 transition-transform"></i>
          </a>
          <a routerLink="/contact" class="bg-transparent border-2 border-blue-500 text-blue-300 hover:bg-blue-500/10 font-bold py-4 px-10 rounded-xl transition-all duration-300 flex items-center justify-center group">
            <span>Contact Us</span>
            <i class="bx bx-phone ml-2 text-xl"></i>
          </a>
        </div>
        
        <div class="grid grid-cols-1 sm:grid-cols-3 gap-6 max-w-2xl mx-auto lg:mx-0">
          <div class="bg-blue-500/10 backdrop-blur-sm rounded-xl p-6 border border-blue-500/30">
            <div class="text-3xl font-bold text-blue-400 mb-2">Zero</div>
            <div class="text-sm text-gray-400">RPO</div>
          </div>
          <div class="bg-blue-500/10 backdrop-blur-sm rounded-xl p-6 border border-blue-500/30">
            <div class="text-3xl font-bold text-blue-400 mb-2">24/7</div>
            <div class="text-sm text-gray-400">Protection</div>
          </div>
          <div class="bg-blue-500/10 backdrop-blur-sm rounded-xl p-6 border border-blue-500/30">
            <div class="text-3xl font-bold text-blue-400 mb-2">Instant</div>
            <div class="text-sm text-gray-400">Recovery</div>
          </div>
        </div>
      </div>
      
      <div class="relative">
        <div class="relative z-10 rounded-3xl overflow-hidden shadow-2xl border border-gray-700/50 backdrop-blur-sm">
          <img src="assets/img/cdp-backup-hero.png" alt="IIS CDP Backup" class="w-full h-auto">
        </div>
        
        <div class="absolute -top-8 -left-8 bg-gradient-to-br from-blue-600 to-indigo-700 rounded-2xl p-6 shadow-2xl w-56 border border-blue-500/30">
          <div class="flex items-center">
            <i class="bx bx-infinite text-3xl mr-3"></i>
            <div>
              <div class="text-2xl font-bold text-white">Real-time</div>
              <div class="text-sm text-blue-200">Backup</div>
            </div>
          </div>
        </div>
        
        <div class="absolute -bottom-8 -right-8 bg-gradient-to-br from-indigo-600 to-blue-700 rounded-2xl p-6 shadow-2xl w-56 border border-indigo-500/30">
          <div class="flex items-center">
            <i class="bx bx-time text-3xl mr-3"></i>
            <div>
              <div class="text-2xl font-bold text-white">Instant</div>
              <div class="text-sm text-indigo-200">Recovery</div>
            </div>
          </div>
        </div>
        
        <!-- Floating Elements -->
        <div class="absolute top-1/4 -right-12 w-16 h-16 bg-gradient-to-br from-cyan-400 to-blue-500 rounded-2xl flex items-center justify-center shadow-xl animate-bounce border border-cyan-300">
          <i class="bx bx-shield-quarter text-2xl text-white"></i>
        </div>
        
        <div class="absolute bottom-1/4 -left-12 w-16 h-16 bg-gradient-to-br from-purple-400 to-pink-500 rounded-2xl flex items-center justify-center shadow-xl animate-pulse border border-purple-300">
          <i class="bx bx-data text-2xl text-white"></i>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Features Section -->
<section class="py-24 bg-gradient-to-b from-gray-900 to-gray-950">
  <div class="container mx-auto px-4">
    <div class="text-center mb-20">
      <div class="inline-block bg-gradient-to-r from-blue-500/20 to-purple-500/20 backdrop-blur-sm px-6 py-2 rounded-full mb-6 border border-blue-500/30">
        <span class="text-lg font-medium text-blue-300">Backup Features</span>
      </div>
      <h2 class="text-4xl md:text-5xl font-bold text-white mb-6">
        Enterprise Data <span class="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-cyan-300">Protection</span>
      </h2>
      <p class="text-xl text-gray-400 max-w-3xl mx-auto">
        Continuous data protection with real-time backup and instant recovery capabilities for mission-critical applications.
      </p>
    </div>

    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
      <!-- Continuous Protection -->
      <div class="bg-gradient-to-br from-gray-800/50 to-gray-900/50 backdrop-blur-sm rounded-2xl shadow-2xl p-8 hover:shadow-3xl transition-all duration-500 border border-gray-700/50 transform hover:-translate-y-3 group">
        <div class="w-20 h-20 bg-gradient-to-br from-blue-500 to-cyan-600 rounded-2xl flex items-center justify-center mb-8 group-hover:rotate-12 transition-transform">
          <i class="bx bx-infinite text-4xl text-white"></i>
        </div>
        <h3 class="text-2xl font-bold text-white mb-4">Continuous Protection</h3>
        <p class="text-gray-400 mb-6">
          Real-time backup with continuous data protection and zero RPO for your critical business data.
        </p>
        <div class="flex items-center text-blue-400 font-semibold">
          <i class="bx bx-check-circle mr-3"></i>
          <span class="text-sm">Zero data loss</span>
        </div>
      </div>

      <!-- Instant Recovery -->
      <div class="bg-gradient-to-br from-gray-800/50 to-gray-900/50 backdrop-blur-sm rounded-2xl shadow-2xl p-8 hover:shadow-3xl transition-all duration-500 border border-gray-700/50 transform hover:-translate-y-3 group">
        <div class="w-20 h-20 bg-gradient-to-br from-cyan-500 to-blue-600 rounded-2xl flex items-center justify-center mb-8 group-hover:rotate-12 transition-transform">
          <i class="bx bx-time text-4xl text-white"></i>
        </div>
        <h3 class="text-2xl font-bold text-white mb-4">Instant Recovery</h3>
        <p class="text-gray-400 mb-6">
          Recover data to any point in time with instant recovery capabilities and minimal RTO.
        </p>
        <div class="flex items-center text-blue-400 font-semibold">
          <i class="bx bx-check-circle mr-3"></i>
          <span class="text-sm">Point-in-time restore</span>
        </div>
      </div>

      <!-- Enterprise Security -->
      <div class="bg-gradient-to-br from-gray-800/50 to-gray-900/50 backdrop-blur-sm rounded-2xl shadow-2xl p-8 hover:shadow-3xl transition-all duration-500 border border-gray-700/50 transform hover:-translate-y-3 group">
        <div class="w-20 h-20 bg-gradient-to-br from-indigo-500 to-purple-600 rounded-2xl flex items-center justify-center mb-8 group-hover:rotate-12 transition-transform">
          <i class="bx bx-shield text-4xl text-white"></i>
        </div>
        <h3 class="text-2xl font-bold text-white mb-4">Enterprise Security</h3>
        <p class="text-gray-400 mb-6">
          AES-256 encryption at rest and in transit with compliance certifications for data security.
        </p>
        <div class="flex items-center text-blue-400 font-semibold">
          <i class="bx bx-check-circle mr-3"></i>
          <span class="text-sm">Military-grade encryption</span>
        </div>
      </div>

      <!-- Application Aware -->
      <div class="bg-gradient-to-br from-gray-800/50 to-gray-900/50 backdrop-blur-sm rounded-2xl shadow-2xl p-8 hover:shadow-3xl transition-all duration-500 border border-gray-700/50 transform hover:-translate-y-3 group">
        <div class="w-20 h-20 bg-gradient-to-br from-purple-500 to-pink-600 rounded-2xl flex items-center justify-center mb-8 group-hover:rotate-12 transition-transform">
          <i class="bx bx-server text-4xl text-white"></i>
        </div>
        <h3 class="text-2xl font-bold text-white mb-4">Application Aware</h3>
        <p class="text-gray-400 mb-6">
          Application-consistent snapshots for IIS and database applications ensuring data integrity.
        </p>
        <div class="flex items-center text-blue-400 font-semibold">
          <i class="bx bx-check-circle mr-3"></i>
          <span class="text-sm">Consistent snapshots</span>
        </div>
      </div>

      <!-- Cloud Ready -->
      <div class="bg-gradient-to-br from-gray-800/50 to-gray-900/50 backdrop-blur-sm rounded-2xl shadow-2xl p-8 hover:shadow-3xl transition-all duration-500 border border-gray-700/50 transform hover:-translate-y-3 group">
        <div class="w-20 h-20 bg-gradient-to-br from-green-500 to-emerald-600 rounded-2xl flex items-center justify-center mb-8 group-hover:rotate-12 transition-transform">
          <i class="bx bx-cloud text-4xl text-white"></i>
        </div>
        <h3 class="text-2xl font-bold text-white mb-4">Cloud Ready</h3>
        <p class="text-gray-400 mb-6">
          Seamless integration with cloud storage for offsite backup protection and disaster recovery.
        </p>
        <div class="flex items-center text-blue-400 font-semibold">
          <i class="bx bx-check-circle mr-3"></i>
          <span class="text-sm">Hybrid backup</span>
        </div>
      </div>

      <!-- Automated Testing -->
      <div class="bg-gradient-to-br from-gray-800/50 to-gray-900/50 backdrop-blur-sm rounded-2xl shadow-2xl p-8 hover:shadow-3xl transition-all duration-500 border border-gray-700/50 transform hover:-translate-y-3 group">
        <div class="w-20 h-20 bg-gradient-to-br from-amber-500 to-orange-600 rounded-2xl flex items-center justify-center mb-8 group-hover:rotate-12 transition-transform">
          <i class="bx bx-test-tube text-4xl text-white"></i>
        </div>
        <h3 class="text-2xl font-bold text-white mb-4">Automated Testing</h3>
        <p class="text-gray-400 mb-6">
          Automated recovery testing to ensure backup integrity and reliability with regular validation.
        </p>
        <div class="flex items-center text-blue-400 font-semibold">
          <i class="bx bx-check-circle mr-3"></i>
          <span class="text-sm">Verified backups</span>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Benefits Section -->
<section class="py-24 bg-gradient-to-b from-gray-950 to-gray-900">
  <div class="container mx-auto px-4">
    <div class="text-center mb-20">
      <div class="inline-block bg-gradient-to-r from-blue-500/20 to-purple-500/20 backdrop-blur-sm px-6 py-2 rounded-full mb-6 border border-blue-500/30">
        <span class="text-lg font-medium text-blue-300">Key Benefits</span>
      </div>
      <h2 class="text-4xl md:text-5xl font-bold text-white mb-6">
        Why Choose <span class="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-cyan-300">IIS CDP Backup</span>
      </h2>
      <p class="text-xl text-gray-400 max-w-3xl mx-auto">
        Comprehensive data protection solution designed specifically for IIS environments with enterprise-grade features.
      </p>
    </div>

    <div class="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto">
      <!-- Zero RPO -->
      <div class="bg-gradient-to-br from-gray-800/50 to-gray-900/50 backdrop-blur-sm rounded-2xl shadow-2xl p-8 border border-gray-700/50 hover:shadow-3xl transition-all duration-300">
        <div class="flex items-start mb-6">
          <div class="w-16 h-16 bg-gradient-to-br from-blue-600 to-cyan-700 rounded-2xl flex items-center justify-center mr-6 flex-shrink-0">
            <i class="bx bx-infinite text-3xl text-white"></i>
          </div>
          <div>
            <h3 class="text-2xl font-bold text-white mb-2">Zero RPO Protection</h3>
            <p class="text-gray-400 mb-4">
              Continuous data protection ensures zero recovery point objective with real-time backup of all changes.
            </p>
            <ul class="space-y-2">
              <li class="flex items-center text-gray-300">
                <i class="bx bx-check-circle text-blue-400 mr-2"></i>
                <span class="text-sm">No data loss between backups</span>
              </li>
              <li class="flex items-center text-gray-300">
                <i class="bx bx-check-circle text-blue-400 mr-2"></i>
                <span class="text-sm">Real-time change tracking</span>
              </li>
              <li class="flex items-center text-gray-300">
                <i class="bx bx-check-circle text-blue-400 mr-2"></i>
                <span class="text-sm">Continuous protection 24/7</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <!-- Instant Recovery -->
      <div class="bg-gradient-to-br from-gray-800/50 to-gray-900/50 backdrop-blur-sm rounded-2xl shadow-2xl p-8 border border-gray-700/50 hover:shadow-3xl transition-all duration-300">
        <div class="flex items-start mb-6">
          <div class="w-16 h-16 bg-gradient-to-br from-cyan-600 to-blue-700 rounded-2xl flex items-center justify-center mr-6 flex-shrink-0">
            <i class="bx bx-time text-3xl text-white"></i>
          </div>
          <div>
            <h3 class="text-2xl font-bold text-white mb-2">Instant Recovery</h3>
            <p class="text-gray-400 mb-4">
              Restore data instantly to any point in time with minimal RTO and quick recovery operations.
            </p>
            <ul class="space-y-2">
              <li class="flex items-center text-gray-300">
                <i class="bx bx-check-circle text-cyan-400 mr-2"></i>
                <span class="text-sm">Point-in-time recovery</span>
              </li>
              <li class="flex items-center text-gray-300">
                <i class="bx bx-check-circle text-cyan-400 mr-2"></i>
                <span class="text-sm">Granular file-level restore</span>
              </li>
              <li class="flex items-center text-gray-300">
                <i class="bx bx-check-circle text-cyan-400 mr-2"></i>
                <span class="text-sm">Fast full system recovery</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <!-- Security & Compliance -->
      <div class="bg-gradient-to-br from-gray-800/50 to-gray-900/50 backdrop-blur-sm rounded-2xl shadow-2xl p-8 border border-gray-700/50 hover:shadow-3xl transition-all duration-300">
        <div class="flex items-start mb-6">
          <div class="w-16 h-16 bg-gradient-to-br from-indigo-600 to-purple-700 rounded-2xl flex items-center justify-center mr-6 flex-shrink-0">
            <i class="bx bx-shield text-3xl text-white"></i>
          </div>
          <div>
            <h3 class="text-2xl font-bold text-white mb-2">Security & Compliance</h3>
            <p class="text-gray-400 mb-4">
              Enterprise security with encryption and compliance certifications for regulated industries.
            </p>
            <ul class="space-y-2">
              <li class="flex items-center text-gray-300">
                <i class="bx bx-check-circle text-indigo-400 mr-2"></i>
                <span class="text-sm">AES-256 encryption</span>
              </li>
              <li class="flex items-center text-gray-300">
                <i class="bx bx-check-circle text-indigo-400 mr-2"></i>
                <span class="text-sm">Compliance ready (HIPAA, GDPR)</span>
              </li>
              <li class="flex items-center text-gray-300">
                <i class="bx bx-check-circle text-indigo-400 mr-2"></i>
                <span class="text-sm">Audit trail & reporting</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <!-- Easy Management -->
      <div class="bg-gradient-to-br from-gray-800/50 to-gray-900/50 backdrop-blur-sm rounded-2xl shadow-2xl p-8 border border-gray-700/50 hover:shadow-3xl transition-all duration-300">
        <div class="flex items-start mb-6">
          <div class="w-16 h-16 bg-gradient-to-br from-green-600 to-emerald-700 rounded-2xl flex items-center justify-center mr-6 flex-shrink-0">
            <i class="bx bx-cog text-3xl text-white"></i>
          </div>
          <div>
            <h3 class="text-2xl font-bold text-white mb-2">Easy Management</h3>
            <p class="text-gray-400 mb-4">
              Intuitive dashboard and automated workflows for effortless backup management and monitoring.
            </p>
            <ul class="space-y-2">
              <li class="flex items-center text-gray-300">
                <i class="bx bx-check-circle text-green-400 mr-2"></i>
                <span class="text-sm">Centralized management</span>
              </li>
              <li class="flex items-center text-gray-300">
                <i class="bx bx-check-circle text-green-400 mr-2"></i>
                <span class="text-sm">Automated scheduling</span>
              </li>
              <li class="flex items-center text-gray-300">
                <i class="bx bx-check-circle text-green-400 mr-2"></i>
                <span class="text-sm">Real-time monitoring</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="py-24 bg-gradient-to-b from-gray-900 to-gray-950">
  <div class="container mx-auto px-4">
    <div class="text-center mb-16">
      <div class="inline-block bg-gradient-to-r from-blue-500/20 to-purple-500/20 backdrop-blur-sm px-6 py-2 rounded-full border border-blue-500/30">
        <span class="text-lg font-medium text-blue-300">How It Works</span>
      </div>
      <h2 class="text-4xl md:text-5xl font-bold text-white mb-6">
        End-to-End Continuous Data Protection
      </h2>
      <p class="text-xl text-gray-400 max-w-3xl mx-auto">
        A streamlined flow that captures every change, secures it, and enables instant recovery.
      </p>
    </div>

    <div class="grid grid-cols-1 md:grid-cols-4 gap-8">
      <div class="bg-gradient-to-br from-gray-800/50 to-gray-900/50 rounded-2xl p-8 border border-gray-700/50">
        <div class="w-16 h-16 bg-gradient-to-br from-blue-600 to-cyan-700 rounded-2xl flex items-center justify-center mb-6">
          <i class="bx bx-copy-alt text-3xl text-white"></i>
        </div>
        <h3 class="text-xl font-bold text-white mb-2">Change Capture</h3>
        <p class="text-gray-400">Capture every write operation with near-zero overhead.</p>
      </div>
      <div class="bg-gradient-to-br from-gray-800/50 to-gray-900/50 rounded-2xl p-8 border border-gray-700/50">
        <div class="w-16 h-16 bg-gradient-to-br from-indigo-600 to-purple-700 rounded-2xl flex items-center justify-center mb-6">
          <i class="bx bx-transfer text-3xl text-white"></i>
        </div>
        <h3 class="text-xl font-bold text-white mb-2">Replication</h3>
        <p class="text-gray-400">Stream changes to secure local or cloud targets.</p>
      </div>
      <div class="bg-gradient-to-br from-gray-800/50 to-gray-900/50 rounded-2xl p-8 border border-gray-700/50">
        <div class="w-16 h-16 bg-gradient-to-br from-teal-600 to-emerald-700 rounded-2xl flex items-center justify-center mb-6">
          <i class="bx bx-shield text-3xl text-white"></i>
        </div>
        <h3 class="text-xl font-bold text-white mb-2">Retention & Security</h3>
        <p class="text-gray-400">Encrypt, retain, and index for fast point-in-time restores.</p>
      </div>
      <div class="bg-gradient-to-br from-gray-800/50 to-gray-900/50 rounded-2xl p-8 border border-gray-700/50">
        <div class="w-16 h-16 bg-gradient-to-br from-amber-600 to-orange-700 rounded-2xl flex items-center justify-center mb-6">
          <i class="bx bx-refresh text-3xl text-white"></i>
        </div>
        <h3 class="text-xl font-bold text-white mb-2">Instant Recovery</h3>
        <p class="text-gray-400">Restore to any second with minimal downtime.</p>
      </div>
    </div>
  </div>
</section>

<section class="py-24 bg-gradient-to-b from-gray-950 to-gray-900">
  <div class="container mx-auto px-4">
    <div class="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
      <div>
        <div class="inline-block bg-gradient-to-r from-blue-500/20 to-purple-500/20 backdrop-blur-sm px-6 py-2 rounded-full border border-blue-500/30 mb-6">
          <span class="text-lg font-medium text-blue-300">Integrations</span>
        </div>
        <h3 class="text-3xl font-bold text-white mb-6">Supported Targets & Platforms</h3>
        <div class="grid grid-cols-2 md:grid-cols-3 gap-6">
          <div class="bg-gray-800/50 rounded-xl p-6 border border-gray-700/50 text-center">
            <i class="bx bxl-aws text-4xl text-yellow-400"></i>
            <div class="text-gray-300 mt-2 text-sm">Amazon S3</div>
          </div>
          <div class="bg-gray-800/50 rounded-xl p-6 border border-gray-700/50 text-center">
            <i class="bx bxl-microsoft text-4xl text-blue-400"></i>
            <div class="text-gray-300 mt-2 text-sm">Azure Blob</div>
          </div>
          <div class="bg-gray-800/50 rounded-xl p-6 border border-gray-700/50 text-center">
            <i class="bx bxl-google-cloud text-4xl text-blue-300"></i>
            <div class="text-gray-300 mt-2 text-sm">GCS</div>
          </div>
          <div class="bg-gray-800/50 rounded-xl p-6 border border-gray-700/50 text-center">
            <i class="bx bx-server text-4xl text-gray-200"></i>
            <div class="text-gray-300 mt-2 text-sm">On‑Prem NAS</div>
          </div>
          <div class="bg-gray-800/50 rounded-xl p-6 border border-gray-700/50 text-center">
            <i class="bx bx-cloud text-4xl text-cyan-300"></i>
            <div class="text-gray-300 mt-2 text-sm">Hybrid</div>
          </div>
          <div class="bg-gray-800/50 rounded-xl p-6 border border-gray-700/50 text-center">
            <i class="bx bx-lock-alt text-4xl text-emerald-300"></i>
            <div class="text-gray-300 mt-2 text-sm">Immutable</div>
          </div>
        </div>
      </div>
      <div>
        <div class="inline-block bg-gradient-to-r from-emerald-500/20 to-teal-500/20 backdrop-blur-sm px-6 py-2 rounded-full border border-emerald-500/30 mb-6">
          <span class="text-lg font-medium text-emerald-300">Compliance</span>
        </div>
        <h3 class="text-3xl font-bold text-white mb-6">Security & Regulatory</h3>
        <div class="grid grid-cols-2 md:grid-cols-4 gap-6">
          <div class="bg-gray-800/50 rounded-xl p-5 border border-gray-700/50 text-center">
            <div class="text-white font-semibold">ISO 27001</div>
          </div>
          <div class="bg-gray-800/50 rounded-xl p-5 border border-gray-700/50 text-center">
            <div class="text-white font-semibold">SOC 2</div>
          </div>
          <div class="bg-gray-800/50 rounded-xl p-5 border border-gray-700/50 text-center">
            <div class="text-white font-semibold">HIPAA</div>
          </div>
          <div class="bg-gray-800/50 rounded-xl p-5 border border-gray-700/50 text-center">
            <div class="text-white font-semibold">GDPR</div>
          </div>
        </div>
        <div class="mt-8 grid grid-cols-1 md:grid-cols-2 gap-6">
          <div class="bg-gray-800/50 rounded-xl p-6 border border-gray-700/50">
            <div class="text-gray-300">Encryption</div>
            <div class="text-white text-2xl font-bold">AES‑256</div>
          </div>
          <div class="bg-gray-800/50 rounded-xl p-6 border border-gray-700/50">
            <div class="text-gray-300">Integrity</div>
            <div class="text-white text-2xl font-bold">Verified</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="py-24 bg-gradient-to-b from-gray-900 to-gray-950">
  <div class="container mx-auto px-4">
    <div class="text-center mb-12">
      <div class="inline-block bg-gradient-to-r from-blue-500/20 to-purple-500/20 backdrop-blur-sm px-6 py-2 rounded-full border border-blue-500/30">
        <span class="text-lg font-medium text-blue-300">FAQ</span>
      </div>
      <h2 class="text-4xl md:text-5xl font-bold text-white mt-4">Frequently Asked Questions</h2>
    </div>
    <div class="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto">
      <div class="bg-gray-800/50 rounded-2xl p-6 border border-gray-700/50">
        <div class="text-white font-semibold mb-2">What is RPO vs RTO?</div>
        <div class="text-gray-400">RPO is acceptable data loss; RTO is acceptable downtime. This solution targets 0 RPO and minimal RTO.</div>
      </div>
      <div class="bg-gray-800/50 rounded-2xl p-6 border border-gray-700/50">
        <div class="text-white font-semibold mb-2">Can I restore to any second?</div>
        <div class="text-gray-400">Yes, point‑in‑time recovery enables second‑level precision for restores.</div>
      </div>
      <div class="bg-gray-800/50 rounded-2xl p-6 border border-gray-700/50">
        <div class="text-white font-semibold mb-2">Is data encrypted at rest?</div>
        <div class="text-gray-400">All backups are encrypted at rest and in transit using modern ciphers.</div>
      </div>
      <div class="bg-gray-800/50 rounded-2xl p-6 border border-gray-700/50">
        <div class="text-white font-semibold mb-2">Does it support hybrid storage?</div>
        <div class="text-gray-400">Yes, you can use cloud targets alongside on‑prem storage for redundancy.</div>
      </div>
    </div>
  </div>
</section>

<!-- CTA Section -->
<section class="py-24 bg-gradient-to-br from-blue-900/50 to-indigo-900/50">
  <div class="container mx-auto px-4">
    <div class="text-center max-w-4xl mx-auto">
      <h2 class="text-4xl md:text-5xl font-bold text-white mb-6">
        Protect Your Critical Data with <span class="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-cyan-300">IIS CDP Backup</span>
      </h2>
      <p class="text-xl text-gray-300 mb-12">
        Get enterprise-grade continuous data protection with zero data loss and instant recovery for your mission-critical IIS applications.
      </p>
      
      <div class="flex flex-col sm:flex-row gap-6 justify-center mb-12">
        <a routerLink="/contact" class="bg-gradient-to-r from-blue-600 to-indigo-700 hover:from-blue-700 hover:to-indigo-800 text-white font-bold py-4 px-10 rounded-xl transition-all duration-300 transform hover:-translate-y-1 shadow-2xl hover:shadow-blue-500/20 inline-flex items-center justify-center">
          <i class="bx bx-shield-quarter mr-2 text-xl"></i>
          <span class="text-lg">Start Protection</span>
        </a>
        <a routerLink="/contact" class="bg-transparent border-2 border-blue-500 text-blue-300 hover:bg-blue-500/10 font-bold py-4 px-10 rounded-xl transition-all duration-300 inline-flex items-center justify-center">
          <i class="bx bx-phone mr-2 text-xl"></i>
          <span class="text-lg">Contact Sales</span>
        </a>
      </div>
      
      <div class="grid grid-cols-2 md:grid-cols-4 gap-8 max-w-4xl mx-auto">
        <div class="bg-blue-500/10 backdrop-blur-sm rounded-xl p-6 border border-blue-500/30">
          <div class="text-3xl font-bold text-blue-400 mb-2">0</div>
          <div class="text-sm text-gray-400">RPO</div>
        </div>
        <div class="bg-blue-500/10 backdrop-blur-sm rounded-xl p-6 border border-blue-500/30">
          <div class="text-3xl font-bold text-blue-400 mb-2">&lt;15min</div>
          <div class="text-sm text-gray-400">RTO</div>
        </div>
        <div class="bg-blue-500/10 backdrop-blur-sm rounded-xl p-6 border border-blue-500/30">
          <div class="text-3xl font-bold text-blue-400 mb-2">24/7</div>
          <div class="text-sm text-gray-400">Protection</div>
        </div>
        <div class="bg-blue-500/10 backdrop-blur-sm rounded-xl p-6 border border-blue-500/30">
          <div class="text-3xl font-bold text-blue-400 mb-2">AES-256</div>
          <div class="text-sm text-gray-400">Encryption</div>
        </div>
      </div>
    </div>
  </div>
</section>
